export const LinkListWidgetId = 'LinkListWidget';

export enum LinkListWidgetAttributes {
  TITLE = 'text',
  LINKS = 'linkList',
}
